import { Square2StackIcon } from "@heroicons/react/24/outline";
import { Box, HStack, Icon, Text, useClipboard } from "@highoutput/ui-components";
import { LinkedinShareButton, TwitterShareButton } from "react-share";
import LinkedInIcon from "../icons/linked-in";
import TwitterIcon from "../icons/twitter";

export default function ShareButtons({ url }: { url: string }) {
  const { hasCopied, onCopy } = useClipboard(url);

  return (
    <HStack spacing="12px">
      <HStack
        as="button"
        aria-label="Copy"
        onClick={onCopy}
        sx={{ ...buttonStyles, paddingX: "16px" }}
      >
        <Icon as={Square2StackIcon} width="20px" height="20px" />
        <Text variant="14/14" color="rgba(13,48,80,0.8)" fontWeight="medium" letterSpacing="0.02em">
          {hasCopied ? "Copied" : "Copy link"}
        </Text>
      </HStack>

      <TwitterShareButton url={url}>
        <Box sx={buttonStyles}>
          <TwitterIcon fill="#1DA1F2" width="20px" height="20px" />
        </Box>
      </TwitterShareButton>

      <LinkedinShareButton url={url}>
        <Box sx={buttonStyles}>
          <LinkedInIcon fill="#0A66C2" width="20px" height="20px" />
        </Box>
      </LinkedinShareButton>
    </HStack>
  );
}

const buttonStyles = {
  padding: "10px",
  border: "1px solid #D1D1D1",
  borderColor: "rgba(240,237,236,0.4)",
  borderRadius: "4px",
  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
  ":hover": {
    backgroundColor: "#FAFAFA",
  },
};
